var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("发票开具周期？")]),_c('div',{staticClass:"content-info"},[_c('p',{staticClass:"txt1"},[_vm._v("\n      自发票申请提交之日起，预计需要4至7个工作日；\n      "),_c('br'),_vm._v("若订单中包含第三方卖家商品，该商品发票由卖家提供，预计将在发票需求日期后的12个工作日内送达。\n    ")])])])
}]

export { render, staticRenderFns }